import { render, staticRenderFns } from "./OrderPromiseList.vue?vue&type=template&id=1d83c81a"
import script from "./OrderPromiseList.vue?vue&type=script&lang=js"
export * from "./OrderPromiseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports